import { Component, HostListener } from '@angular/core';
import { FormGroup, FormBuilder } from '@angular/forms';
import { Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { MenuItem, SortEvent } from 'primeng/api';
import { DynamicDialogRef, DialogService } from 'primeng/dynamicdialog';
import Swal from 'sweetalert2';
import { Viewdata, GlobalMessage,Signatory } from '../../utility/modals';
import { Utilityservice } from '../../utility/utilityservice.service';
import { SignatorydetailsService } from './signatorydetails.service';
import { PagehelpmodalService } from '../../directives/pagehelpmodal/pagehelpmodal.service';
import { SignatorymodalComponent } from '../../directives/signatorymodal/signatorymodal.component';
import { ExceldownloadComponent } from '../../directives/exceldownload/exceldownload.component';
@Component({
  selector: 'app-signatorydetails',
  templateUrl: './signatorydetails.component.html',
  styleUrls: ['./signatorydetails.component.css']
})
export class SignatorydetailsComponent {
  signatoryForm: FormGroup
  selectedItem: MenuItem | null = null;
  items: MenuItem[] | undefined;
  tableData: any[] = [];
  isDropdownOpen = false;
  excel_paragraph = '';
  templatedownloadtext = '';
  exceldownloadModal = false;
  downloadformate = false;
  showcount: number = 0;
  hidecount: number = 0;
  searchText: string;
  sortOrder = 1;
  sortProperty: string = 'id';
  signatoryRequest: Signatory = new Signatory();
  signatoryUpdatereq: Signatory = new Signatory();
  signatory: any;
  signatorysarray: Array<Signatory>;
  signatorytype: any;
  signatoryarray: Array<Signatory> = [];
  signatorylist: any;
  signatorylistarray: Array<Signatory> = [];
  dataview: Viewdata = new Viewdata();
  ref: DynamicDialogRef | undefined;
  buttunText = "Add New"
  isButtonraised: boolean = true;
  commonScrollHeight = '';
  page: number = 1;
  count: number = 0;
  tableSize: number = 10;
  tableSizes: any = [10, 20, 50, 100];
  tablecount: number = 0;
  first2: number = 0;
  rows2: number = 10;
  totalRecords: number = 0;
  selectedProduct = false;
  options = [];
  paginatorArray
  visible: boolean = false;
  psition = 'top';
  cols = [];
  _selectedColumns = [];
  bulkModal = false;
  message: GlobalMessage = new GlobalMessage()
  isEdit = false;
  isAdd = true;
  isClose = false;
  isView = false;
  isTableHeaderCustomized: boolean = false;
  isActivefilter = false

  constructor(
    private SignatorydetailsService: SignatorydetailsService,
    public router: Router,
    private fb: FormBuilder,
    public dialogService: DialogService,
    //private dashbordservice: DashboardService,
    public helpservice: PagehelpmodalService,
    private utilityservice: Utilityservice, private spinner: NgxSpinnerService) {
    this.excel_paragraph = this.message.downloadexcel_text;
    this.templatedownloadtext = this.message.excelformate_text;
  }

  ngOnInit() {
    this.commonScrollHeight = this.utilityservice.updateScrollHeight();
    this.gettabledata();
    this.formInitialized();
    this.dynamiccols(); 
  }

  onMenuItemClick(event: any): void {
    this.selectedItem = event.item;
    if (this.selectedItem.command) {
      this.selectedItem.command();
    }
  }

  @HostListener('window:resize', ['$event'])
  onResize() {
    this.commonScrollHeight = this.utilityservice.updateScrollHeight();
  }

  dynamiccols() {
    this.showcount = 8;
    this.hidecount = 3;
    this.cols = [];

    this.cols.push(
      { fieldname: 'rid', headername: 'ID', fieldtype: 'text', issort: true, ischecked: true, width: '2px !important', class: 'headerid' },
      { fieldname: 'usertypeflag', headername: 'EXT/INT User', fieldtype: 'text', issort: true, ischecked: true, width: '2px !important', class: 'otherheader' },
      { fieldname: "name", headername: "User Name", fieldtype: 'text', issort: true, ischecked: true, width: '20px', class: 'otherheader' },
      { fieldname: "email", headername: "Email", fieldtype: 'text', issort: true, ischecked: true, width: '20px', class: 'otherheader' },
      { fieldname: "mobno", headername: "Mobile", fieldtype: 'text', issort: true, ischecked: true, width: '20px', class: 'otherheader' },
      { fieldname: "createdon", headername: "Created On", fieldtype: 'text', issort: false, ischecked: true, width: '20px', class: 'otherheader' },
      { fieldname: "createdby", headername: "Created By", fieldtype: 'text', issort: true, ischecked: true, width: '20px', class: 'otherheader' },
      { fieldname: "activeflag", headername: "Status", fieldtype: 'text', issort: true, ischecked: true, width: '20px', class: 'otherheader' },
    )
    this._selectedColumns = this.cols;
    // const payload = {
    //   userid: this.utilityservice.getLoggeduser().userid,
    //   orgid: this.utilityservice.getLoggeduser().orgid,
    //   productid: this.utilityservice.productdetail().productid,
    //   componentname: 'sdlcsignatory'
    // }
    // this.spinner.show();
    // this.utilityservice.getuserxcolumn(payload).subscribe(res => {
    //   this.spinner.hide();
    //   this.cols.forEach(column => {
    //     const matchingColumn = res.find(x => x.fieldname === column.fieldname);
    //     if (matchingColumn) {
    //       column.ischecked = matchingColumn.ischecked;
    //       column.issort = matchingColumn.issort;
    //     }
    //   });
    //   this._selectedColumns = this.cols;
    //   this.isTableHeaderCustomized = this.cols.some(col => col.ischecked !== true);
    // }, error => {
    //   this.spinner.hide();
    //   console.error('Error getting user columns:', error);
    //   Swal.fire('Error getting header filter', 'Please try again later', 'error');
    // })
    // this.utilityservice.headerObservable.next(this.cols);

  }
  showTableColumns() {
    this.isActivefilter = !this.isActivefilter;
  }


  gettabledata() {
    this.SignatorydetailsService.gettabledata().subscribe((data) => {
      this.signatorylist = data;
      this.signatorylistarray = this.signatorylist;
      this.options = this.SignatorydetailsService.getOptionDropdown(data.length);
      this.paginatorArray = this.options.map(e => e.value)
      this.signatorylistarray.map(e => {
        e['isSelect'] = false
      })
      this.totalRecords = this.signatorylistarray.length;
      this.tablecount = this.signatorylist.count;
    });

    this.SignatorydetailsService.gettabledata().subscribe((data: any) => {
      this.signatorylist = data;
    });
  }

  //Get signatory by Id
  tempuse: any;
  getsignatory() {
    this.spinner.show();
    this.SignatorydetailsService.gettabledata().subscribe((data) => {
      this.signatorylist = data;
      this.signatorylistarray = this.signatorylist;
      this.tablecount = this.signatorylist.count;
      this.spinner.hide();
      this.options = this.SignatorydetailsService.getOptionDropdown(data.length);
      this.paginatorArray = this.options.map(e => e.value)
    }
      , error => {
        this.spinner.hide();
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: error.error.error,
          footer: "error status is :" + ' ' + error.status
        });
      });
  }

  show(title, data) {
    let details = {}
    if (title === 'Modify Signatory Data') {
      this.isEdit = true;
      this.SignatorydetailsService.getmodify(data.rid).subscribe(res => {
        details = res;
        this.ref = this.dialogService.open(SignatorymodalComponent, {
          header: title,
          width: '60vw',
          height: 'auto',
          data: { title: title, datas: details },
          contentStyle: { overflow: 'auto' },
          baseZIndex: 10000,
          maximizable: false,
        });
        this.ref.onClose.subscribe(() => {
          this.getsignatory();
        });
      })
    }
    else {
      details = {}
      this.ref = this.dialogService.open(SignatorymodalComponent, {
        header: title,
        width: '60vw',
        height: 'auto',
        data: { title: title, datas: details },
        contentStyle: { overflow: 'auto' },
        baseZIndex: 10000,
        maximizable: false,
      });
      this.ref.onClose.subscribe(() => {
        this.getsignatory();
      });
    }
  }



  formInitialized() {
    this.signatoryForm = this.fb.group({
      signatoryname: [''],
      signatoryid: [''],
      activeflag: ['Y']
    })
  }
  handlePageChange(event: any) {
    this.rows2 = event.rows
  }
  filedata: any = []
  setEvent(event) {
    this.filedata = event

  }

  handleDialogClose() {
    this.filedata = [];
  }


  customSort(event: SortEvent) {
    event.data.sort((data1, data2) => {
      let value1 = data1[event.field];
      let value2 = data2[event.field];
      let result = 0;
      // Convert date strings to Date objects if they are valid date formats
      const isDate = (date) => !isNaN(Date.parse(date));

      if (value1 == null && value2 != null) result = -1;
      else if (value1 != null && value2 == null) result = 1;
      else if (value1 == null && value2 == null) result = 0;
      else if (typeof value1 === 'string' && typeof value2 === 'string') {
        // Check for specific sorting logic for processstepname
        if (event.field === 'title') {
          result = value1.toLowerCase().localeCompare(value2.toLowerCase());
        } else if (isDate(value1) && isDate(value2)) {
          const date1 = new Date(value1);
          const date2 = new Date(value2);
          result = date1 < date2 ? -1 : date1 > date2 ? 1 : 0;
        } else {
          result = value1.localeCompare(value2);
        }
      } else {
        // Fallback to default number comparison
        result = value1 < value2 ? -1 : value1 > value2 ? 1 : 0;
      }

      return event.order * result;  // Multiply by order (-1 for descending, 1 for ascending)
    });
  }


  exceDownloadModel() {
    let payload = {}
    this.ref = this.dialogService.open(ExceldownloadComponent, {
      header: "Excel Download",
      width: '44vw',
      height: '10vw',
      data: {
        excelname: "Signatories_data.xlsx", downloadapi: 'common/signatorydetails/DataExcel',
        method: 'get', message: this.excel_paragraph, payload: payload
      },
      contentStyle: { overflow: 'hidden' },
      position: 'center'

    })
  }



  searchTerm: string = '';
  cleanRegExp(str: string): string {
    return str.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
  }

  highlight(input: string, searchstring: string | number): string {
    if (!searchstring) return input;
    const safeText = String(input ?? '');
    const safeSearch = this.cleanRegExp(String(searchstring));
    const re = new RegExp(safeSearch, 'gi');
    return safeText.replace(re, match => `<span class="highlightsearch">${match}</span>`);
  }
}
